//@ts-check
import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';

import { ContainerContext } from '../../../utils';
import getUserEntitlements from '../actions/get-user-entitlements';

/** @param {import('@action-types/userEntitlement').UseCcEntitlementsOptions} [options] */
const useCcEntitlements = (options = {}) => {
  const { ims } = useContext(ContainerContext);
  const token = ims?.getAccessToken()?.token;

  const enabled = Boolean(token && (options?.enabled ?? true));

  const data = useQuery({
    enabled,
    queryKey: ['get-cc-entitlements', token],
    queryFn: async ({ signal }) =>
      getUserEntitlements({
        token,
        signal,
      }),
    ...options,
  });

  return data;
};

export default useCcEntitlements;
